import React from 'react';

// i18n
import { withTranslation } from 'react-i18next';

// Routes
import { withRouter } from 'react-router-dom';

// redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Components
import {
  Menu
} from 'semantic-ui-react';

import {
  toggleAppSidebar
} from '../../modules/app';
import styled from 'styled-components';

const DesktopSidebarToggle = styled(Menu.Item)`
  @media only screen and (max-width: 767px) {
    display: none !important;
  }
`;

const BookWorkspaceSidebarToggle = styled(Menu.Item)`
  @media only screen and (max-width: 767px) {
    display: flex !important;
    min-width: 44px;
    min-height: 44px;
    align-items: center;
    justify-content: center;
  }
`;

export const isBookWorkspacePath = pathname =>
  /^\/books\/[^/]+/.test(pathname || '');

export const SidebarToggler = ({
  sidebarVisible,
  userProfile,
  location,

  toggleAppSidebar
}) => {
  const isBookWorkspace = !!userProfile && isBookWorkspacePath(location?.pathname);
  const Toggle = isBookWorkspace
    ? BookWorkspaceSidebarToggle
    : userProfile
      ? DesktopSidebarToggle
      : Menu.Item;

  return (
    <Toggle
      fitted
      key='menu-opener'
      aria-label={isBookWorkspace ? 'Open book menu' : 'Open menu'}
      icon={isBookWorkspace && sidebarVisible ? 'close' : 'bars'}
      onClick={() => toggleAppSidebar(!sidebarVisible)}
    />
  );
}

// redux stuff
const mapStateToProps = state => ({
  sidebarVisible: state.app.sidebarVisible,
  userProfile: state.user.userProfile,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  toggleAppSidebar,
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(SidebarToggler)));
